import { Injectable } from '@angular/core';

import { IProviderAuth } from '@core/auth/interfaces/IProviderAuth';
import { LoginPayload } from '../interfaces/login-payload';
import { User } from 'src/app/models/user';
import { Observable } from 'rxjs';
@Injectable({
    providedIn: 'root',
})
export class AuthService {
    provider!: IProviderAuth;
    login(loginPayload?: LoginPayload): Promise<any> {
        return this.provider.login(loginPayload);
    }

    logout(): Promise<void> {
        return this.provider.logout();
    }

    getCurrentUser(): Promise<any> {
        return this.provider.getCurrentUser();
    }

    getLoggedUser(): Observable<User | null> {
        return this.provider.getLoggedUser();
    }

     sendRecoveryEmail(email: string) {
        return this.provider.sendRecoveryEmail(email,'administration');
    }
}
